export default __webpack_public_path__ + "static/media/greyTerraform.cc458319.svg";